(() => {
  var trackedEvents = [
    'reference_cta_click',
    'reference_pdf_download',
    'reference_calendly_click',
    'reference_contact_success',
    'diy_project_cta_click',
    'landing_consultation_click',
    'landing_acheck_start',
    'landing_product_click',
    'landing_reference_click',
    'landing_photo_email_click',
    'landing_form_start',
    'landing_lead_submit',
    'landing_room_select',
    'landing_calc_start',
    'landing_calc_use',
    'landing_calc_cta',
    'landing_download_click',
    'landing_sample_click',
    'landing_tender_click',
    'header_cta_click',
    'quote_modal_open',
    // Makro-Conversions (TRACKING-KONZEPT.md §4): GA4-Standardnamen. Beide werden
    // erst gesendet, wenn Shopify die Anfrage nachweislich angenommen hat — siehe
    // Anfrage-Merker weiter unten.
    'generate_lead',
    'pdp_quote_submit',
    // Firmenkonto-Antrag (Shopify Forms) — gesendet von snippets/firmenkonto-danke-tracking.liquid.
    'firmenkonto_antrag',
  ];

  // Kampagnen-Herkunft einer Anfrage. Eine Liste fuer alle Formulare: Kontaktseite,
  // Beratungsformular und Angebots-Modal (dort per attribution() beim Absenden).
  // Neue Parameter hier ergaenzen UND in den drei Formularen je ein Hidden Field
  // anlegen (snippets/kontakt-page.liquid, consultation-form.liquid, pdp-quote-modal.liquid).
  // utm_medium unterscheidet bezahlt/Newsletter/Social; msclkid ist die Klick-ID von
  // Microsoft Ads, das Gegenstueck zu gclid.
  var attributionFields = [
    {
      param: 'utm_source',
      storageKey: 'fennext_utm_source',
      selector: '[data-contact-utm-source]',
    },
    {
      param: 'utm_medium',
      storageKey: 'fennext_utm_medium',
      selector: '[data-contact-utm-medium]',
    },
    {
      param: 'utm_campaign',
      storageKey: 'fennext_utm_campaign',
      selector: '[data-contact-utm-campaign]',
    },
    { param: 'utm_term', storageKey: 'fennext_utm_term', selector: '[data-contact-utm-term]' },
    {
      param: 'utm_content',
      storageKey: 'fennext_utm_content',
      selector: '[data-contact-utm-content]',
    },
    { param: 'gclid', storageKey: 'fennext_gclid', selector: '[data-contact-gclid]' },
    { param: 'msclkid', storageKey: 'fennext_msclkid', selector: '[data-contact-msclkid]' },
  ];
  // Die Quellen-Handles standen hier frueher als drittes Duplikat neben den
  // Page-Metafeldern und dem case/when in templates/page.landing.liquid. Eine neue
  // Landingpage haette also auch hier gepflegt werden muessen, sonst faellt still
  // das Tracking aus. Jetzt kommen Handle und Typ vom ausloesenden Element selbst.

  function sessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return '';
    }
  }

  function sessionSet(key, value) {
    if (!value) return;
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  // Nur für Marketing-Attribution (UTM, GCLID, Kampagnenquelle) — schreibt erst
  // nach erteilter Einwilligung. Siehe Consent-Gate weiter unten.
  function sessionSetMarketing(key, value) {
    if (!value) return;
    if (trackingAllowed() !== true) return;
    sessionSet(key, value);
  }

  function sessionRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  // ── Consent-Gate ──────────────────────────────────────────────────────────
  // Marketing-Attribution (UTM/GCLID im sessionStorage) und dataLayer-Pushes an
  // GTM sind NICHT "unbedingt erforderlich" i. S. d. § 25 Abs. 2 Nr. 2 TDDDG.
  // Vorher liefen beide ungated bei jedem Seitenaufruf. Jetzt hängen sie an
  // Shopifys Customer-Privacy-API; bis eine Entscheidung vorliegt, wird
  // gepuffert statt geschrieben. Funktionale Speicher (z. B. das Akustik-Ziel
  // in pdp-acheck) sind bewusst nicht betroffen.
  var pendingEvents = [];

  function consentApi() {
    return window.Shopify?.customerPrivacy;
  }

  function trackingAllowed() {
    var api = consentApi();
    if (!api) return null; // noch unbekannt
    try {
      return Boolean(api.analyticsProcessingAllowed() || api.marketingAllowed());
    } catch (_error) {
      return null;
    }
  }

  function writeEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function flushPending() {
    if (trackingAllowed() !== true) {
      pendingEvents = [];
      return;
    }
    var queued = pendingEvents;
    pendingEvents = [];
    queued.forEach(writeEvent);
  }

  document.addEventListener('visitorConsentCollected', () => {
    flushPending();
    herkunftMerken();
  });

  // visitorConsentCollected feuert nur, wenn der Banner JETZT bedient wird. Wer
  // frueher schon zugestimmt hat, loest es nie aus — war die Consent-API beim
  // Puffern nur noch nicht geladen, blieb das Ereignis liegen. Fuer die
  // Anfrage-Conversions nach dem Neuladen waere das der Normalfall. Deshalb kurz
  // nachfragen, bis die API eine Antwort hat (max. ~10 s), dann ausliefern.
  var consentPoll = null;
  function waitForConsentApi() {
    if (consentPoll) return;
    var attempts = 0;
    consentPoll = window.setInterval(() => {
      attempts += 1;
      var allowed = trackingAllowed();
      if (allowed !== null || attempts >= 40) {
        window.clearInterval(consentPoll);
        consentPoll = null;
        // Nur bei Zustimmung ausliefern. Bei "noch nicht entschieden" liefert die
        // API ebenfalls false — der Puffer bleibt dann fuer visitorConsentCollected.
        if (allowed === true) {
          flushPending();
          herkunftMerken();
        }
      }
    }, 250);
  }

  // extra: zusaetzliche Felder fuer Conversions (value, currency, lead_type,
  // product_sku, user_data …). Kann die Grundfelder nicht ueberschreiben.
  function pushEvent(eventName, contentHandle, destination, contentType, extra) {
    if (trackedEvents.indexOf(eventName) === -1) return;
    var payload = {};
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach((key) => {
        payload[key] = extra[key];
      });
    }
    payload.event = eventName;
    payload.content_handle = contentHandle || 'unknown';
    payload.content_type = contentType || 'unknown';
    payload.project_handle = contentHandle || 'unknown';
    payload.source_page = window.location.pathname;
    payload.destination = destination || window.location.href;
    var allowed = trackingAllowed();
    if (allowed === true) {
      writeEvent(payload);
      return;
    }
    // Consent-API noch nicht bereit: puffern, aber begrenzt.
    if (allowed === null && pendingEvents.length < 20) {
      pendingEvents.push(payload);
      waitForConsentApi();
    }
  }

  // Aktuelle Kampagnen-Herkunft: Parameter der aktuellen URL, sonst der in dieser
  // Sitzung gemerkte Wert (gemerkt wird nur nach Einwilligung, sessionSetMarketing).
  function attribution() {
    var parameters = new URLSearchParams(window.location.search);
    var result = {};
    attributionFields.forEach((field) => {
      result[field.param] = parameters.get(field.param) || sessionGet(field.storageKey) || '';
    });
    result.landing_page = sessionGet('fennext_landing_page') || '';
    result.referrer = sessionGet('fennext_referrer') || '';
    return result;
  }

  // Einstiegsseite und fremder Referrer der Sitzung (ANFRAGEFORMULAR-KONZEPT.md §7).
  // Gleiche Regel wie UTM: gemerkt wird nur nach Einwilligung. Ohne Query —
  // dort stehen gclid/UTM, die schon eigene Felder haben.
  // Laeuft beim Laden und noch einmal, sobald die Einwilligung vorliegt
  // (visitorConsentCollected bzw. Consent-Poll) — sonst verliert ein Erstbesucher,
  // der den Banner auf der Einstiegsseite bedient, Einstiegsseite, Referrer und UTM.
  function herkunftMerken() {
    var parameters = new URLSearchParams(window.location.search);
    attributionFields.forEach((field) => {
      sessionSetMarketing(field.storageKey, parameters.get(field.param));
    });
    if (!sessionGet('fennext_landing_page')) {
      sessionSetMarketing('fennext_landing_page', window.location.pathname);
    }
    var ref = document.referrer || '';
    if (ref && !sessionGet('fennext_referrer')) {
      try {
        const url = new URL(ref);
        if (url.host !== window.location.host) {
          sessionSetMarketing('fennext_referrer', url.origin + url.pathname);
        }
      } catch (_error) {
        // kein gueltiger Referrer
      }
    }
  }

  // ── Anfrage-Merker ────────────────────────────────────────────────────────
  // Alle Anfrageformulare senden nativ ab: Shopifys Spam-Schutz (hCaptcha) haengt
  // seinen Token nur beim echten Absenden ein, ein fetch-Versand scheitert mit 400
  // (pdp-quote-modal.liquid). Die Seite laedt danach mit ?contact_posted=true neu.
  // Deshalb zwei Haelften:
  // 1. Beim Absenden merkt merkeAnfrage() die Conversion-Daten in der Sitzung.
  // 2. Nach dem Neuladen meldet anfrageErfolgMelden() sie genau einmal — nur wenn
  //    Shopify Erfolg rendert UND ein Merker da ist. Der Merker wird dabei geloescht;
  //    ein Neuladen der Danke-Seite zaehlt also nicht noch einmal. Genau das tat der
  //    bisherige GTM-Trigger auf contact_posted=true in der URL.
  // Vorher fing ihn der GTM-Formular-Trigger ab — der feuert seit dem hCaptcha nie,
  // weil das Captcha per form.submit() absendet und kein submit-Ereignis entsteht.
  var LEAD_KEY = 'fennext_lead_pending';
  var LEAD_EMAIL_KEY = 'fennext_lead_email';
  var LEAD_MAX_AGE_MS = 60 * 60 * 1000;

  function trackingConfig() {
    var config = window.FennextTrackingConfig || {};
    return {
      formularWert: Number(config.formularWert) || 0,
      abschlussquote: Number(config.abschlussquote) || 0,
      waehrung: config.waehrung || 'EUR',
    };
  }

  function marketingAllowed() {
    var api = consentApi();
    if (!api) return false;
    try {
      return Boolean(api.marketingAllowed());
    } catch (_error) {
      return false;
    }
  }

  // data: { event, lead_type, content_handle, email, listenwert, product_sku, quantity }
  // Ohne Einwilligung wird nichts gemerkt — dann gaebe es ohnehin kein Ereignis.
  // Die E-Mail (fuer Erweiterte Conversions, gehasht erst durch Google) nur mit
  // Werbe-Einwilligung, und sie bleibt nur bis zur Rueckkehr in der Sitzung.
  function merkeAnfrage(data) {
    if (!data || trackedEvents.indexOf(data.event) === -1) return;
    if (trackingAllowed() !== true) return;
    var config = trackingConfig();
    var value =
      data.event === 'pdp_quote_submit'
        ? Math.round((((Number(data.listenwert) || 0) * config.abschlussquote) / 100) * 100) / 100
        : config.formularWert;
    var record = {
      event: data.event,
      lead_type: data.lead_type || 'unknown',
      content_handle: data.content_handle || '',
      value: value,
      currency: config.waehrung,
      ts: Date.now(),
    };
    if (data.product_sku) record.product_sku = data.product_sku;
    if (data.quantity) record.quantity = data.quantity;
    if (data.listenwert) record.listenwert = data.listenwert;
    sessionSet(LEAD_KEY, JSON.stringify(record));
    sessionRemove(LEAD_EMAIL_KEY);
    if (data.email && marketingAllowed()) sessionSet(LEAD_EMAIL_KEY, data.email);
  }

  function anfrageErfolgMelden() {
    var raw = sessionGet(LEAD_KEY);
    var email = sessionGet(LEAD_EMAIL_KEY);
    sessionRemove(LEAD_KEY);
    sessionRemove(LEAD_EMAIL_KEY);
    if (!raw) return;
    var record;
    try {
      record = JSON.parse(raw);
    } catch (_error) {
      return;
    }
    if (!record || !record.event || Date.now() - Number(record.ts) > LEAD_MAX_AGE_MS) return;
    var extra = { lead_type: record.lead_type, value: record.value, currency: record.currency };
    if (record.product_sku) extra.product_sku = record.product_sku;
    if (record.quantity) extra.quantity = record.quantity;
    if (record.listenwert) extra.listenwert = record.listenwert;
    if (email) extra.user_data = { email: email };
    pushEvent(
      record.event,
      record.content_handle || window.location.pathname,
      'shopify_contact_form',
      record.lead_type,
      extra,
    );
  }

  // Kontaktseite und Beratungsformular. Capture-Phase, damit der Merker auch dann
  // steht, wenn ein Skript am Formular die Weitergabe des Ereignisses stoppt.
  // Das Angebots-Modal merkt selbst (es kennt Positionen und Preise), und Shopifys
  // Newsletter-Formular (form_type=customer) ist keine Anfrage.
  document.addEventListener(
    'submit',
    (event) => {
      var form = event.target;
      if (!form || form.id === 'quote-modal-form') return;
      var formType = form.querySelector('input[name="form_type"]');
      if (!formType || formType.value !== 'contact') return;
      var leadForm = form.closest('[data-lead-form]');
      var storedType = sessionGet('fennext_contact_source_type');
      var emailField = form.querySelector('[name="contact[email]"]');
      // Header und Footer ("Angebot anfragen") fuehren ins Beratungsformular und
      // stellen dort das Leistungsinteresse auf den Angebotswert der Sektion
      // (data-quote-interest, uebersetzt) — Vergleich mit dem Attribut, nicht mit
      // dem Wort, damit es auch auf /en/ greift.
      var interestField = form.querySelector('[data-consultation-interest]');
      var quoteSection = document.querySelector('[data-quote-interest]');
      var isQuote =
        interestField &&
        quoteSection &&
        interestField.value !== '' &&
        interestField.value === quoteSection.getAttribute('data-quote-interest');
      merkeAnfrage({
        event: 'generate_lead',
        lead_type: isQuote ? 'angebot' : storedType || (leadForm ? 'beratung' : 'kontakt'),
        content_handle:
          leadForm?.getAttribute('data-lead-form') || sessionGet('fennext_contact_source') || '',
        email: emailField ? emailField.value.trim() : '',
      });
    },
    true,
  );

  window.FennextTracking = Object.freeze({
    push: pushEvent,
    attribution: attribution,
    merkeAnfrage: merkeAnfrage,
    werbungErlaubt: marketingAllowed,
    herkunftMerken: herkunftMerken,
  });

  // Die Sektion #beratung-anfrage bedient mehrere Einstiege: Remote-Analyse, Vor-Ort-
  // Projekt und — aus Header und Footer — das Angebot. Ueberschrift, Vorspann und
  // Absende-Button wechseln dabei gemeinsam. Vorher wechselte nur die Ueberschrift:
  // ueber dem Formular stand "Remote-Analyse anfragen", auf dem Knopf darunter
  // "Kostenlose Ersteinschaetzung anfragen".
  function applyConsultationIntent(interest, heading, intro, submit) {
    var interestField = document.querySelector('[data-consultation-interest]');
    var headingElement = document.querySelector('[data-consultation-form-heading]');
    var introElement = document.querySelector('[data-consultation-form-intro]');
    var submitElement = document.querySelector('[data-consultation-form-submit]');
    if (interestField && interest) interestField.value = interest;
    if (headingElement && heading) headingElement.textContent = heading;
    if (introElement && intro) introElement.textContent = intro;
    if (submitElement && submit) submitElement.textContent = submit;
  }

  function initCollectionPage() {
    var page = document.querySelector('[data-collection-page]');
    if (!page) return;

    var drawer = page.querySelector('[data-facets-drawer]');
    var triggers = Array.from(page.querySelectorAll('[data-facets-open]'));
    var lastTrigger = null;

    function setTriggerState(expanded) {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(expanded));
      });
    }

    function focusableElements() {
      if (!drawer) return [];
      return Array.from(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
        ),
      ).filter((element) => element.offsetParent !== null);
    }

    function openDrawer(trigger) {
      if (!drawer) return;
      lastTrigger = trigger;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('facets-open');
      setTriggerState(true);

      window.setTimeout(() => {
        var focusTarget = drawer.querySelector('[data-facets-close]');
        if (focusTarget) focusTarget.focus();
      }, 30);
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('facets-open');
      setTriggerState(false);
      if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openDrawer(trigger));
    });

    if (drawer) {
      drawer.querySelectorAll('[data-facets-close]').forEach((button) => {
        button.addEventListener('click', closeDrawer);
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDrawer();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = focusableElements();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    // Die Kategoriezeile scrollt auf dem Handy waagerecht (666px Inhalt in 355px). Bei den
    // hinteren Kategorien lag die aktive Markierung dadurch ausserhalb des Bildschirms —
    // der Kunde sah nicht, wo er ist. Sie wird an den rechten Rand geholt, nicht zentriert:
    // So bleiben die vorherigen Eintraege links angeschnitten und zeigen, dass die Zeile
    // weitergeht.
    var catswitch = page.querySelector('[data-catswitch]');
    var activeCategory = catswitch ? catswitch.querySelector('.catswitch__link--active') : null;
    var catswitchPadding = 16;
    var activeCategoryRight;
    if (activeCategory && catswitch.scrollWidth > catswitch.clientWidth) {
      activeCategoryRight = activeCategory.offsetLeft + activeCategory.offsetWidth;
      if (activeCategoryRight > catswitch.clientWidth - catswitchPadding) {
        catswitch.scrollLeft = activeCategoryRight - catswitch.clientWidth + catswitchPadding;
      }
    }

    var sort = page.querySelector('[data-collection-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  }

  document.addEventListener('click', (event) => {
    var sourceType;
    var target = event.target.closest('[data-track]');
    if (!target) return;

    var contentHandle =
      target.getAttribute('data-content-handle') || target.getAttribute('data-project-handle');
    var trackingEvent = target.getAttribute('data-track');
    // Handle UND Typ mitgeben: Auf der Kontaktseite ist der ausloesende CTA nicht
    // mehr im DOM, der Typ laesst sich dort also nicht rekonstruieren.
    // Schreiben geht ueber sessionSetMarketing, also erst nach Einwilligung.
    // reference_cta_click gehoert mit in die Weiche: Die Referenz-CTAs
    // (sections/reference-case.liquid, templates/page.referenzen.liquid) tragen kein
    // data-content-type, und kein Element im Theme setzt den Wert "reference". Ohne
    // diesen Zweig bliebe fennext_contact_source_type leer, die Auswertung unten
    // fiele in den else-Zweig — jede Referenz-Anfrage waere als Landing-Lead
    // gezaehlt worden und reference_contact_success haette nie mehr gefeuert.
    if (
      (trackingEvent === 'landing_consultation_click' || trackingEvent === 'reference_cta_click') &&
      contentHandle
    ) {
      sourceType = trackingEvent === 'reference_cta_click' ? 'reference' : 'landing';
      sessionSetMarketing('fennext_contact_source', contentHandle);
      sessionSetMarketing(
        'fennext_contact_source_type',
        target.getAttribute('data-content-type') || sourceType,
      );
    }

    var serviceInterest = target.getAttribute('data-service-interest');
    if (serviceInterest) {
      applyConsultationIntent(
        serviceInterest,
        target.getAttribute('data-form-heading'),
        null,
        target.getAttribute('data-form-submit'),
      );
    }

    pushEvent(
      trackingEvent,
      contentHandle,
      target.href || target.getAttribute('data-destination'),
      target.getAttribute('data-content-type'),
    );
  });

  var startedLeadForms = {};
  document.addEventListener('focusin', (event) => {
    var leadForm = event.target.closest('[data-lead-form]');
    if (!leadForm) return;

    var contentHandle = leadForm.getAttribute('data-lead-form');
    if (startedLeadForms[contentHandle]) return;

    startedLeadForms[contentHandle] = true;
    sessionSetMarketing('fennext_contact_source', contentHandle);
    pushEvent('landing_form_start', contentHandle, 'shopify_contact_form', 'consultation');
  });

  // Leere Felder nicht mitschicken (ANFRAGEFORMULAR-KONZEPT.md Entscheidung 30): Shopify
  // haengt jedes contact[...]-Feld an die Mail, auch leere ("Phone:", "Einsatzbereich:"),
  // und das Team antwortet direkt darauf. Laeuft am Dokument in der Bubble-Phase, also nach
  // den Formular-eigenen submit-Handlern, die erst dort Felder wie den Mailtext fuellen.
  // Name entfernen statt disabled: Shopifys Captcha sendet spaeter per form.submit() ohne
  // neues submit-Ereignis. Bearbeitet jemand das Feld danach (Absenden blockiert), bekommt
  // es seinen Namen zurueck; nach "Zurueck" aus dem Browser-Cache ebenso (pageshow).
  var KONTAKT_PFLICHTFELDER = ['contact[name]', 'contact[email]', 'contact[body]'];
  function leereFelderWeglassen(form) {
    if (!form.querySelectorAll) return;
    var felder = form.querySelectorAll(
      'input[name^="contact["], select[name^="contact["], textarea[name^="contact["]',
    );
    Array.prototype.forEach.call(felder, (feld) => {
      if (KONTAKT_PFLICHTFELDER.indexOf(feld.name) > -1) return;
      if (feld.type === 'checkbox' || feld.type === 'radio') return;
      if (String(feld.value || '').trim() !== '') return;
      var name = feld.name;
      feld.setAttribute('data-name-weg', name);
      feld.removeAttribute('name');
      var zurueck = () => {
        feld.name = name;
        feld.removeEventListener('input', zurueck);
        feld.removeEventListener('change', zurueck);
      };
      feld.addEventListener('input', zurueck);
      feld.addEventListener('change', zurueck);
    });
  }
  document.addEventListener('submit', (event) => {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var typ = form.querySelector('input[name="form_type"]');
    if (!typ || typ.value !== 'contact') return;
    leereFelderWeglassen(form);
  });
  window.addEventListener?.('pageshow', () => {
    Array.prototype.forEach.call(document.querySelectorAll('[data-name-weg]'), (feld) => {
      feld.name = feld.getAttribute('data-name-weg');
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    herkunftMerken();
    if (trackingAllowed() === null) waitForConsentApi();
    initCollectionPage();

    // Formular-Ergebnis nach dem Reload in den Fokus holen, damit Screenreader
    // und Tastaturnutzer die Rueckmeldung ueberhaupt erreichen. Kontakt- und
    // Firmenkonto-Formular haben kein data-autofocus, ihre Meldung zaehlt mit.
    // Selbst scrollen statt per focus(): Der Anker-Sprung des Browsers ist nicht
    // verlaesslich, und nachladende Bilder darueber verschieben das Ziel noch.
    // 'instant', weil die Seite scroll-behavior: smooth hat und eine laufende
    // Animation das (noch wandernde) Ziel verfehlen kann.
    var announced = document.querySelector(
      '[data-autofocus], form > .contact-success, form > .contact-errors',
    );
    if (announced) {
      if (!announced.hasAttribute('tabindex')) announced.setAttribute('tabindex', '-1');
      announced.focus({ preventScroll: true });
      const meldungZeigen = () => {
        // Spaet ladende Skripte (Chat, Consent) nehmen den Fokus sonst wieder weg.
        if (document.activeElement === document.body) announced.focus({ preventScroll: true });
        var rect = announced.getBoundingClientRect();
        if (rect.top < 96 || rect.bottom > window.innerHeight) {
          announced.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      };
      meldungZeigen();
      window.addEventListener('load', meldungZeigen, { once: true });
    }

    var matchingArea;
    var parameters = new URLSearchParams(window.location.search);
    // querySelectorAll statt querySelector: Steht mehr als ein Formular auf der
    // Seite, bekam bisher nur das erste die Herkunft.
    attributionFields.forEach((field) => {
      var parameterValue = parameters.get(field.param);
      if (parameterValue) sessionSetMarketing(field.storageKey, parameterValue);
      document.querySelectorAll(field.selector).forEach((formField) => {
        formField.value = parameterValue || sessionGet(field.storageKey);
      });
    });
    [
      ['[data-contact-landing-page]', 'fennext_landing_page'],
      ['[data-contact-referrer]', 'fennext_referrer'],
    ].forEach(([selector, key]) => {
      document.querySelectorAll(selector).forEach((formField) => {
        formField.value = sessionGet(key) || '';
      });
    });

    var subjectMap = {
      angebot: 'Angebot & B2B',
      beratung: 'Akustikberatung',
      musterpaket: 'Musterpaket',
      versand: 'Bestellung & Versand',
    };
    var subject = subjectMap[parameters.get('betreff')];
    var subjectSelect = document.getElementById('contact-betreff');
    if (subject && subjectSelect) subjectSelect.value = subject;

    var area = parameters.get('bereich');
    var areaSelect = document.getElementById('contact-bereich');
    // Die Projektfelder stecken in einem zugeklappten <details>. Ohne das Aufklappen
    // sieht der Nutzer die Vorbelegung aus dem Landing-CTA nie und traegt den
    // Bereich ggf. doppelt in den Freitext ein.
    var areaDetails = areaSelect?.closest('details');
    if (area && areaSelect) {
      matchingArea = Array.from(areaSelect.options).some((option) => option.value === area);
      if (matchingArea) {
        areaSelect.value = area;
        if (areaDetails) areaDetails.open = true;
      }
    }

    // Header und Footer springen mit `?interesse=angebot` auf #beratung-anfrage. Die
    // Texte kommen aus den Datenattributen der Sektion (snippets/consultation-proof.liquid),
    // weil diese Datei ein statisches Asset ist und `| t` nicht aufloesen kann.
    var quoteSection = document.querySelector('[data-quote-heading]');
    if (quoteSection && parameters.get('interesse') === 'angebot') {
      applyConsultationIntent(
        quoteSection.getAttribute('data-quote-interest'),
        quoteSection.getAttribute('data-quote-heading'),
        quoteSection.getAttribute('data-quote-intro'),
        quoteSection.getAttribute('data-quote-submit'),
      );
    }

    // Telefonfeld haengt per CSS :has() am Rueckruf-Haken. Ohne JS-Kopplung sendet
    // "Rueckruf gewuenscht" ein leeres Telefonfeld ab und das Formular bestaetigt trotzdem.
    document.querySelectorAll('.consult-form__callback').forEach((group) => {
      var toggle = group.querySelector('.consult-form__check input[type="checkbox"]');
      var wrap = group.querySelector('.consult-form__phone');
      var field = wrap?.querySelector('input[type="tel"]');
      if (!toggle || !wrap || !field) return;
      var sync = () => {
        wrap.hidden = !toggle.checked;
        field.required = toggle.checked;
        field.setAttribute('aria-required', toggle.checked ? 'true' : 'false');
      };
      toggle.addEventListener('change', sync);
      sync();
    });

    var source = parameters.get('quelle');
    var sourceField = document.querySelector('[data-contact-source]');
    if (!source && sourceField) source = sourceField.value;
    // Formatpruefung statt gepflegter Whitelist: der Wert landet in einem Hidden
    // Field und darf nichts Beliebiges enthalten, muss aber nicht jede neue
    // Landingpage kennen.
    if (source && !/^[a-z0-9-]{3,80}$/.test(source)) source = '';
    if (source) sessionSetMarketing('fennext_contact_source', source);
    if (sourceField) sourceField.value = source || sessionGet('fennext_contact_source');

    // Erfolg rendert Shopify ueber form.posted_successfully?: Kontaktseite und
    // Beratungsformular zeigen [data-contact-success], das Angebots-Modal setzt
    // [data-lead-success] an seinem Status-Element.
    var success = document.querySelector('[data-contact-success]');
    if (success || document.querySelector('[data-lead-success]')) anfrageErfolgMelden();
    if (!success) return;

    var storedSource = source || sessionGet('fennext_contact_source');
    var storedType = sessionGet('fennext_contact_source_type');
    if (storedSource) {
      if (storedType === 'reference') {
        pushEvent('reference_contact_success', storedSource, 'shopify_contact_form', 'reference');
      } else {
        pushEvent('landing_lead_submit', storedSource, 'shopify_contact_form', 'landing');
      }
    }
    sessionRemove('fennext_contact_source');
    sessionRemove('fennext_contact_source_type');
  });
})();

/* Kundenbilder-Galerie auf der Referenzseite: Filterleiste und "mehr anzeigen".

   Fortschrittsverbesserung: Ohne JavaScript bleibt die vollstaendige Galerie
   sichtbar und Filterleiste wie Mehr-Button bleiben `hidden`. Das ist der richtige
   Ausfallzustand — lieber alles als nichts.

   Chips ohne Treffer werden entfernt statt ausgegraut. Ein Filter, der auf eine
   leere Galerie fuehrt, ist kein Angebot, sondern eine Sackgasse. Die Zaehlung
   passiert hier statt in Liquid, weil sie dort einen zweiten Durchlauf durch den
   gesamten Pool je Anwendung gekostet haette. */
(() => {
  var SICHTBAR_START = 12;

  document.addEventListener('DOMContentLoaded', () => {
    var galerie = document.querySelector('[data-usecase-gallery]');
    if (!galerie) return;

    var leiste = galerie.querySelector('[data-usecase-filter]');
    var raster = galerie.querySelector('[data-usecase-grid]');
    var leerHinweis = galerie.querySelector('[data-usecase-empty]');
    var mehrHuelle = galerie.querySelector('[data-usecase-more]');
    var mehrButton = galerie.querySelector('[data-usecase-more-button]');
    if (!leiste || !raster) return;

    var karten = Array.prototype.slice.call(raster.querySelectorAll('[data-usecase-tags]'));
    if (!karten.length) return;

    var chips = Array.prototype.slice.call(leiste.querySelectorAll('[data-usecase-value]'));
    var aktiv = 'alle';
    var alleZeigen = false;

    function passt(karte, wert) {
      if (wert === 'alle') return true;
      var tags = (karte.getAttribute('data-usecase-tags') || '').split(/\s+/);
      return tags.indexOf(wert) !== -1;
    }

    // Chips ohne Treffer entfernen, bevor die Leiste sichtbar wird.
    chips = chips.filter((chip) => {
      var wert = chip.getAttribute('data-usecase-value');
      if (wert === 'alle') return true;
      var treffer = karten.some((karte) => passt(karte, wert));
      if (!treffer) chip.remove();
      return treffer;
    });

    function zeichnen() {
      var gezeigt = 0;
      var passende = 0;
      karten.forEach((karte) => {
        if (!passt(karte, aktiv)) {
          karte.hidden = true;
          return;
        }
        passende += 1;
        var zuViel = !alleZeigen && gezeigt >= SICHTBAR_START;
        karte.hidden = zuViel;
        if (!zuViel) gezeigt += 1;
      });

      if (leerHinweis) leerHinweis.hidden = passende > 0;
      if (mehrHuelle) mehrHuelle.hidden = alleZeigen || passende <= SICHTBAR_START;
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        aktiv = chip.getAttribute('data-usecase-value');
        alleZeigen = false;
        chips.forEach((c) => {
          var an = c === chip;
          c.classList.toggle('is-active', an);
          c.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        zeichnen();
      });
    });

    if (mehrButton) {
      mehrButton.addEventListener('click', () => {
        alleZeigen = true;
        zeichnen();
      });
    }

    // Aus #anwendung-kita die Vorauswahl ableiten. So landen Besucher, die von
    // einer Anwendungsseite kommen, direkt im passenden Filter statt in der
    // Gesamtgalerie.
    //
    // Auch auf hashchange hoeren: Wer schon auf dieser Seite steht und einen
    // Ankerlink klickt, loest kein Neuladen aus — ohne diesen Zweig bliebe der
    // Filter stehen und der Sprung fuehrte ins Leere.
    function ausHashWaehlen() {
      var wert = (window.location.hash || '').replace('#anwendung-', '');
      if (!wert) return;
      var treffer = chips.filter((c) => c.getAttribute('data-usecase-value') === wert)[0];
      if (treffer) treffer.click();
    }
    window.addEventListener('hashchange', ausHashWaehlen);
    ausHashWaehlen();

    leiste.hidden = false;
    zeichnen();
  });
})();

/* Landingpages: Raum-Tabs, Ausstattungsbeispiel und Vorbelegung des Anfrageformulars.
   Bausteine aus dem Review vom 2026-09-16 (snippets/landing-raeume.liquid,
   landing-bedarf.liquid, landing-consultation.liquid). Ohne JavaScript bleibt der
   erste Raum sichtbar, der Rechner zeigt Striche und das Formular funktioniert. */
(() => {
  function track(eventName, element) {
    if (!window.FennextTracking) return;
    window.FennextTracking.push(
      eventName,
      element.getAttribute('data-content-handle'),
      element.getAttribute('data-track-label') || '',
      'landing',
    );
  }

  // Raum-Tabs nach dem WAI-ARIA-Tabs-Muster: Pfeiltasten, Pos1, Ende, roving tabindex.
  function initRooms(root) {
    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (tabs.length === 0) return;

    function select(tab, setFocus) {
      tabs.forEach((other) => {
        var active = other === tab;
        other.setAttribute('aria-selected', active ? 'true' : 'false');
        other.tabIndex = active ? 0 : -1;
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (setFocus) tab.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next, true);
      });
    });
  }

  // Ausstattungsbeispiel: gleiche Formel wie der Akustik-Check (sections/rechner.liquid).
  function initNeed(box) {
    var area = box.querySelector('[data-lp-need-area]');
    var areaOut = box.querySelector('[data-lp-need-area-out]');
    if (!area) return;
    var num = (name) => Number.parseFloat(box.getAttribute(name)) || 0;
    var faktor = num('data-faktor') || 1;
    var mwst = num('data-mwst');
    var steuerInklusive = box.getAttribute('data-steuer-inklusive') === 'true';
    var wandAnteil = num('data-wand-anteil') / 100;
    var wandM2 = num('data-wand-m2');
    var wandPreis = num('data-wand-preis');
    var deckeM2 = num('data-decke-m2');
    var deckePreis = num('data-decke-preis');
    var waehrung = box.getAttribute('data-waehrung') || 'EUR';
    var benutzt = false;
    var letzter = { flaeche: 0, bedarf: 0 };

    var zahl = (wert, stellen) =>
      wert.toLocaleString(document.documentElement.lang || 'de', {
        minimumFractionDigits: stellen,
        maximumFractionDigits: stellen,
      });
    var geld = (cent) =>
      (Math.round(cent / 100 / 50) * 50).toLocaleString(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: waehrung,
        maximumFractionDigits: 0,
      });
    var setze = (selektor, text) => {
      var element = box.querySelector(selektor);
      if (element) element.textContent = text;
    };

    function rechne() {
      var flaeche = Number(area.value);
      var gewaehlt = box.querySelector('input[name="lp-need-grade"]:checked');
      var grad = gewaehlt ? Number(gewaehlt.value) : 0.225;
      var bedarf = flaeche * grad * faktor;
      var wand = wandM2 > 0 ? bedarf * wandAnteil : 0;
      var decke = deckeM2 > 0 ? bedarf - wand : 0;
      if (wandM2 === 0) decke = bedarf;
      if (deckeM2 === 0) wand = bedarf;
      var wandStueck = wandM2 > 0 ? Math.ceil(wand / wandM2) : 0;
      var deckeStueck = deckeM2 > 0 ? Math.ceil(decke / deckeM2) : 0;
      var brutto = wandStueck * wandPreis + deckeStueck * deckePreis;
      var netto = brutto;
      if (steuerInklusive && mwst > 0) netto = brutto / (1 + mwst / 100);
      else if (mwst > 0) brutto = netto * (1 + mwst / 100);

      if (areaOut) areaOut.textContent = `${flaeche} m²`;
      setze('[data-lp-need-total]', `${zahl(bedarf, 1)} m²`);
      setze('[data-lp-need-wall]', `${zahl(wand, 1)} m² ≈ ${wandStueck}`);
      setze('[data-lp-need-ceiling]', `${zahl(decke, 1)} m² ≈ ${deckeStueck}`);
      // Spanne statt Einzelbetrag: Der Richtwert ist keine Zusage.
      setze('[data-lp-need-net]', `${geld(netto * 0.9)} – ${geld(netto * 1.15)}`);
      setze('[data-lp-need-gross]', `${geld(brutto * 0.9)} – ${geld(brutto * 1.15)}`);
      letzter = { flaeche: flaeche, bedarf: bedarf };
    }

    function ersteNutzung() {
      if (benutzt) return;
      benutzt = true;
      track('landing_calc_use', box);
    }

    area.addEventListener('input', () => {
      ersteNutzung();
      rechne();
    });
    box.querySelectorAll('input[name="lp-need-grade"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        ersteNutzung();
        rechne();
      });
    });
    var cta = box.querySelector('[data-lp-need-cta]');
    if (cta) {
      cta.addEventListener('click', () => {
        vorbelegen(
          `Richtwert aus dem Ausstattungsbeispiel: ${letzter.flaeche} m² Raum, ca. ${zahl(letzter.bedarf, 1)} m² Absorberfläche.`,
          letzter.flaeche,
        );
      });
    }
    rechne();
  }

  // Formular auf derselben Seite vorbelegen: Einsatzbereich, Nachricht, Fläche.
  function vorbelegen(text, flaeche) {
    var bereich = document.querySelector('[data-lp-consultation]');
    if (!bereich) return;
    var nachricht = bereich.querySelector('textarea[name="contact[body]"]');
    var feld = bereich.querySelector('input[name="contact[Ungefähre Fläche in m²]"]');
    var details = feld ? feld.closest('details') : null;
    if (nachricht && text && nachricht.value.indexOf(text) === -1) {
      nachricht.value = nachricht.value ? `${nachricht.value}\n${text}` : text;
    }
    if (flaeche && feld) {
      feld.value = flaeche;
      if (details) details.open = true;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lp-rooms]').forEach(initRooms);
    document.querySelectorAll('[data-lp-need]').forEach(initNeed);

    var beratung = document.querySelector('[data-lp-consultation]');
    var gebiet = beratung ? beratung.getAttribute('data-lp-bereich') : '';
    var auswahl = beratung
      ? beratung.querySelector('select[name="contact[Einsatzbereich]"]')
      : null;
    if (beratung) {
      if (gebiet && auswahl && Array.from(auswahl.options).some((o) => o.value === gebiet)) {
        auswahl.value = gebiet;
      }
    }

    document.addEventListener('click', (event) => {
      var ausloeser = event.target.closest('[data-lp-prefill]');
      if (ausloeser) vorbelegen(ausloeser.getAttribute('data-lp-prefill'));
    });
  });
})();

/* Hero-Videos (snippets/hero-video.liquid): Startseite und Landing-Hero.

   Fortschrittsverbesserung: Das Hero-Bild liegt immer darunter und bleibt bei
   „Bewegung reduzieren", im Datensparmodus, ohne JavaScript oder bei einem
   Ladefehler stehen. Die Quelle wird erst hier gesetzt (preload="none" plus
   data-src), damit das Video nie mit dem Bild um die Startbandbreite konkurriert.
   Das Handy bekommt das Hochformat-Video, wenn eines gepflegt ist. Ausserhalb des
   Bildschirms pausiert das Video. */
(() => {
  var HANDY = window.matchMedia('(max-width: 760px)');
  var WENIGER_BEWEGUNG = window.matchMedia('(prefers-reduced-motion: reduce)');

  function datenSparen() {
    var verbindung = navigator.connection;
    return Boolean(verbindung && verbindung.saveData);
  }

  function starten(video) {
    var mobil = video.getAttribute('data-src-mobil');
    var quelle = HANDY.matches && mobil ? mobil : video.getAttribute('data-src');
    if (!quelle) return;
    if (quelle === mobil) video.classList.add('is-mobil');

    video.muted = true;
    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
    video.src = quelle;

    var abspielen = () => {
      var versuch = video.play();
      if (versuch && versuch.catch) versuch.catch(() => {});
    };

    // Im Hintergrund-Tab pausiert der Browser stumme Videos und verwirft play().
    // Beim Zurueckkehren also erneut starten, sofern das Video im Bild ist.
    var imBild = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && imBild) abspielen();
    });

    if (!('IntersectionObserver' in window)) {
      abspielen();
      return;
    }
    new IntersectionObserver((eintraege) => {
      eintraege.forEach((eintrag) => {
        imBild = eintrag.isIntersecting;
        if (imBild) abspielen();
        else video.pause();
      });
    }).observe(video);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (WENIGER_BEWEGUNG.matches || datenSparen()) return;
    document.querySelectorAll('[data-hero-video]').forEach(starten);
  });
})();
